<template>
  <forgot-password />
</template>

<script>
import ForgotPassword from '@/components/Auth/Home/ForgotPassword'
export default {
  components: {
    ForgotPassword,
  },
}
</script>

<style></style>
